import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const item = this.el;

		const scrollTop = () => {
			const scrollTop = window.scrollY;
			if (scrollTop > 150) {
				item.classList.add('shown');
			} else {
				item.classList.remove('shown');
			}
		};

		window.addEventListener('scroll', scrollTop);

		scrollTop();

		item.addEventListener("click", () => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	}
}